var map = {
	"./skins/IBC-dyst": [
		194,
		18
	],
	"./skins/IBC-dyst-2025": [
		193,
		19
	],
	"./skins/IBC-dyst-2025.css": [
		551,
		41
	],
	"./skins/IBC-dyst-2025.js": [
		193,
		19
	],
	"./skins/IBC-dyst.css": [
		552,
		40
	],
	"./skins/IBC-dyst.js": [
		194,
		18
	],
	"./skins/aktionaerliga-2024": [
		195,
		17
	],
	"./skins/aktionaerliga-2024.css": [
		553,
		39
	],
	"./skins/aktionaerliga-2024.js": [
		195,
		17
	],
	"./skins/aktionaerliga-2025": [
		196,
		16
	],
	"./skins/aktionaerliga-2025.css": [
		554,
		38
	],
	"./skins/aktionaerliga-2025.js": [
		196,
		16
	],
	"./skins/bibliotekarernes-sep-2024": [
		197,
		15
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		555,
		37
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		197,
		15
	],
	"./skins/boersen-spiel-sep-2024": [
		198,
		14
	],
	"./skins/boersen-spiel-sep-2024.css": [
		556,
		36
	],
	"./skins/boersen-spiel-sep-2024.js": [
		198,
		14
	],
	"./skins/borsgruppenliu-jan-2024": [
		199,
		13
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		557,
		35
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		199,
		13
	],
	"./skins/fynske-bank-sep-2024": [
		200,
		12
	],
	"./skins/fynske-bank-sep-2024.css": [
		558,
		34
	],
	"./skins/fynske-bank-sep-2024.js": [
		200,
		12
	],
	"./skins/ibc-jan-2024": [
		201,
		20
	],
	"./skins/ibc-jan-2024.js": [
		201,
		20
	],
	"./skins/sdu-businessschooldays-2024": [
		202,
		11
	],
	"./skins/sdu-businessschooldays-2024.css": [
		559,
		33
	],
	"./skins/sdu-businessschooldays-2024.js": [
		202,
		11
	],
	"./skins/sdu-businessschooldays-2025": [
		203,
		10
	],
	"./skins/sdu-businessschooldays-2025.css": [
		560,
		32
	],
	"./skins/sdu-businessschooldays-2025.js": [
		203,
		10
	],
	"./skins/skoledyst-oct-2023": [
		204,
		9
	],
	"./skins/skoledyst-oct-2023.css": [
		561,
		31
	],
	"./skins/skoledyst-oct-2023.js": [
		204,
		9
	],
	"./skins/skolernes-aktiedyst-2024": [
		205,
		8
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		562,
		30
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		205,
		8
	],
	"./skins/skolernes-aktiedyst-2025": [
		206,
		7
	],
	"./skins/skolernes-aktiedyst-2025.css": [
		563,
		29
	],
	"./skins/skolernes-aktiedyst-2025.js": [
		206,
		7
	],
	"./skins/sommerdysten-ad-2023": [
		207,
		6
	],
	"./skins/sommerdysten-ad-2023.css": [
		564,
		28
	],
	"./skins/sommerdysten-ad-2023.js": [
		207,
		6
	],
	"./skins/sommerdysten-ak-2023": [
		208,
		5
	],
	"./skins/sommerdysten-ak-2023.css": [
		565,
		27
	],
	"./skins/sommerdysten-ak-2023.js": [
		208,
		5
	],
	"./skins/sommerdysten-is-2023": [
		209,
		4
	],
	"./skins/sommerdysten-is-2023.css": [
		566,
		26
	],
	"./skins/sommerdysten-is-2023.js": [
		209,
		4
	],
	"./skins/sydbank-sep-2020": [
		210,
		3
	],
	"./skins/sydbank-sep-2020.css": [
		567,
		25
	],
	"./skins/sydbank-sep-2020.js": [
		210,
		3
	],
	"./skins/targo-2025": [
		211,
		2
	],
	"./skins/targo-2025.css": [
		568,
		24
	],
	"./skins/targo-2025.js": [
		211,
		2
	],
	"./skins/ung_aktiedyst_2025": [
		212,
		1
	],
	"./skins/ung_aktiedyst_2025.css": [
		569,
		23
	],
	"./skins/ung_aktiedyst_2025.js": [
		212,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		213,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		570,
		22
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		213,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 358;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 358
// module chunks = 42